// extracted by mini-css-extract-plugin
export default {"wrap":"NarrowWrapper_wrap__gWGlN","isCentered":"NarrowWrapper_isCentered__Vrya0"};